<template>
  <div>
    <div
      :class="['animated-background']"
      :style="{
        width,
        height
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '60px'
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.item {
  border-radius: $border-radius;
  padding: 8px;
}
</style>
/// #endif
